/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_Adjust_XpInputs */



/**
* | output |
* | --- |
* | "Adjust a member's XP by hand" |
*
* @param {Pricing_Compare_Leveling_Adjust_XpInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_adjust_xp = /** @type {((inputs?: Pricing_Compare_Leveling_Adjust_XpInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_Adjust_XpInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ручная правка XP участника")
	return /** @type {LocalizedString} */ ("Adjust a member's XP by hand")
});